/* eslint-disable jsx-a11y/no-onchange */
import React, { useState } from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { CateringDeclineReasons } from 'generated/rbi-graphql';

import { ModalMessage } from './styled';

export type SelectionValue = {
  value: string | number;
  label: string;
};
const ModalContentText = styled.div`
  padding: 0 40px 30px 40px;
`;

export const DeclineModalBody: React.FC<{
  onConfirm: () => void;
  onDismiss: () => void;
  onDecline?: (reason: SelectionValue) => void;
  pickupTime?: string;
}> = ({ onDismiss, onDecline = () => {} }) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState<SelectionValue>();
  const declineOrder = () => {
    if (value) {
      onDecline(value);
    }
    onDismiss();
  };
  const options = {
    [CateringDeclineReasons.INVENTORY]: formatMessage({ id: 'inventory' }),
    [CateringDeclineReasons.STAFFING]: formatMessage({ id: 'staffing' }),
    [CateringDeclineReasons.TIMING]: formatMessage({ id: 'timing' }),
  };
  const onSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value: newValue } = event.target;
    setValue({ value: newValue, label: options[newValue] });
  };
  return (
    <>
      <ModalMessage>
        <ModalContentText>{formatMessage({ id: 'declineCateringOrderModal' })}</ModalContentText>
        <select
          aria-label="Decline Order Dropdown"
          data-testid="decline-reason-dropdown"
          id="declineCateringOrderReasonSelect"
          name="Decline Order Dropdown"
          onChange={onSelect}
          required
        >
          <option value="">{formatMessage({ id: 'chooseAnOption' })}</option>
          {Object.entries(options).map(([optionValue, label]) => (
            <option key={optionValue} value={optionValue}>
              {label}
            </option>
          ))}
        </select>
      </ModalMessage>
      <Box position="absolute" bottom="50px" zIndex={String(Styles.zIndex.below)}>
        <ActionButton disabled={!value} onClick={declineOrder}>
          {formatMessage({ id: 'decline' })}
        </ActionButton>
      </Box>
    </>
  );
};
